import React from 'react';
import { Badge } from 'react-bootstrap';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';
import CheckBox from '@spark/ui-components/components/form/CheckBox';

export const premiacaoVeiculoProprioFilterConfig = [
  {
    name: 'NumeroFrota',
    label: 'Numero Frota',
    type: 'text',
    placeholder: 'Filtrar por frota'
  },
  {
    name: 'Placa',
    label: 'Placa',
    type: 'text',
    placeholder: 'Filtrar por placa'
  },
  {
    name: 'Segmento',
    label: 'Segmento',
    type: 'text',
    placeholder: 'Filtrar por segmento'
  },
  {
    name: 'Modelo',
    label: 'Modelo',
    type: 'text',
    placeholder: 'Filtrar por modelo'
  },
  {
    name: 'Motorista',
    label: 'Motorista',
    type: 'text',
    placeholder: 'Filtrar por motorista'
  },
  {
    name: 'Gestor',
    label: 'Gestor',
    type: 'text',
    placeholder: 'Filtrar por gestor'
  },
  {
    name: 'NomeTabelaPremiacao',
    label: 'Tabela Premiacao',
    type: 'text',
    placeholder: 'Filtrar por tabela vinculada'
  }
];

export const getPremiacaoVeiculoProprioColumns = ({
  selectedIds,
  onToggleSelect,
  onToggleSelectAll,
  allPageSelected,
  selectAllDisabled
}) => {
  const selectionHeader = onToggleSelect ? (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      {onToggleSelectAll ? (
        <Tooltip dir="top" text={allPageSelected ? 'Remover selecao da pagina' : 'Selecionar pagina'}>
          <span className="d-inline-flex align-items-center">
            <CheckBox
              name="select-all-premiacao-veiculos"
              checked={!!allPageSelected}
              disabled={!!selectAllDisabled}
              label=""
              onChange={(event) => {
                event.stopPropagation();
                onToggleSelectAll();
              }}
              onClick={(event) => event.stopPropagation()}
            />
          </span>
        </Tooltip>
      ) : null}
      <span>Selecionar</span>
    </div>
  ) : (
    'Selecionar'
  );

  return [
    {
      id: 'select',
      header: () => selectionHeader,
      size: 110,
      enableSorting: false,
      enableCopy: false,
      cell: ({ row }) => {
        const rowId = row.original.id;
        const isSelected = selectedIds?.includes(rowId);
        const isDisabled = row.original.jaVinculadaTabelaAtual;

        if (!onToggleSelect) {
          return null;
        }

        return (
          <Tooltip dir="top" text={isDisabled ? 'Ja vinculada' : isSelected ? 'Remover selecao' : 'Selecionar'}>
            <span className="d-inline-flex align-items-center">
              <CheckBox
                name={`select-premiacao-veiculo-${rowId}`}
                checked={!!isSelected}
                disabled={isDisabled}
                label=""
                onChange={(event) => {
                  event.stopPropagation();
                  onToggleSelect(rowId);
                }}
                onClick={(event) => event.stopPropagation()}
              />
            </span>
          </Tooltip>
        );
      }
    },
    {
      id: 'numeroFrota',
      header: 'Numero Frota',
      accessorKey: 'numeroFrota',
      cell: ({ getValue, row }) => (
        <div className="d-flex align-items-center gap-2">
          <TruncatedText value={getValue() || '-'} maxLength={14} />
          {row.original.jaVinculadaTabelaAtual ? (
            <Badge bg="secondary">Ja vinculada</Badge>
          ) : null}
        </div>
      )
    },
    {
      id: 'placa',
      header: 'Placa',
      accessorKey: 'placa',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={12} />
    },
    {
      id: 'segmento',
      header: 'Segmento',
      accessorKey: 'segmento',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={18} />
    },
    {
      id: 'modelo',
      header: 'Modelo',
      accessorKey: 'modelo',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={22} />
    },
    {
      id: 'motorista',
      header: 'Motorista',
      accessorKey: 'motorista',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={22} />
    },
    {
      id: 'nomesTabelasPremiacao',
      header: 'Tabelas Premiacao',
      accessorKey: 'nomesTabelasPremiacao',
      cell: ({ getValue }) => {
        const texto = getValue() || '-';
        return <TruncatedText value={texto} maxLength={28} />;
      }
    },
    {
      id: 'gestor',
      header: 'Gestor',
      accessorKey: 'gestor',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={20} />
    }
  ];
};
